<template>
  <div class="fourElements">
    <div class="mr20" style="margin-left: auto;">
      <a-button type="primary" @click="add">新增</a-button>
    </div>
  </div>
</template>
<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.fourElements {
  width: 100%;
  background: #ffffff;
  padding: 10px 20px 20px 20px;
  display: flex;
  align-items: center;
}
</style>
